import {
  aslanSources,
  busterSources,
  candySources,
  charleySources,
  duncanSources,
  elvisSources,
  francisSources,
  gabiSources,
  ghostSources,
} from './assets';

export const ImageMarqueeItemsOne = [
  {
    name: 'Aslan',
    state: 'IN',
    sources: aslanSources,
  },
  {
    name: 'Buster',
    state: 'CA',
    sources: busterSources,
  },
  {
    name: 'Candy',
    state: 'VA',
    sources: candySources,
  },
];

export const ImageMarqueeItemsTwo = [
  {
    name: 'Charlie',
    state: 'IN',
    sources: charleySources,
  },
  {
    name: 'Ghost',
    state: 'NV',
    sources: ghostSources,
  },
  {
    name: 'Duncan',
    state: 'CA',
    sources: duncanSources,
  },
];

export const ImageMarqueeItemsThree = [
  {
    name: 'Elvis',
    state: 'VA',
    sources: elvisSources,
  },
  {
    name: 'Francis',
    state: 'VA',
    sources: francisSources,
  },
  {
    name: 'Gabi',
    state: 'VA',
    sources: gabiSources,
  },
];
